import type { Cell } from "@silevis/reactgrid";
import { NonEditableCell } from "@silevis/reactgrid";
import type { ParticipantListRequiredFields } from "./participantListApi";

export function getHeaderCells(requiredFields: ParticipantListRequiredFields): Cell[] {
  return [
    { rowIndex: 0, Template: NonEditableCell, props: { value: "Room/Cabin no." } },
    { rowIndex: 0, Template: NonEditableCell, props: { value: "Room/Cabin type" } },
    { rowIndex: 0, Template: NonEditableCell, props: { value: "#" } },
    { rowIndex: 0, Template: NonEditableCell, props: { value: "Participant" } },
    {
      rowIndex: 0,
      Template: NonEditableCell,
      props: { value: "Name" },
    },
    {
      rowIndex: 0,
      Template: NonEditableCell,
      props: { value: "Surname" },
    },
    requiredFields.dateOfBirth
      ? {
          rowIndex: 0,
          colIndex: 4,
          Template: NonEditableCell,
          props: { value: "Date of birth" },
        }
      : null,
    requiredFields.gender
      ? {
          rowIndex: 0,
          Template: NonEditableCell,
          props: { value: "Sex" },
        }
      : null,
    requiredFields.citizenship
      ? {
          rowIndex: 0,
          Template: NonEditableCell,
          props: { value: "Nationality" },
        }
      : null,
    requiredFields.documentNumber
      ? {
          rowIndex: 0,
          Template: NonEditableCell,
          props: { value: "Document number" },
        }
      : null,
    requiredFields.documentExpiryDate
      ? {
          rowIndex: 0,
          Template: NonEditableCell,
          props: { value: "Expiration date" },
        }
      : null,
  ]
    .filter((v) => !!v)
    .map((c, idx) => ({ ...c, colIndex: idx }));
}
